// extracted by mini-css-extract-plugin
export default {"form":"TaskForm_form__MxhDL","formHeading":"TaskForm_formHeading__PSkA-","input-group":"TaskForm_input-group__4PnjG","message":"TaskForm_message__fCkk6"};